import { render } from "./UserDataConfirm.vue?vue&type=template&id=676e7204&scoped=true&ts=true"
import script from "./UserDataConfirm.vue?vue&type=script&lang=ts"
export * from "./UserDataConfirm.vue?vue&type=script&lang=ts"

import "./UserDataConfirm.vue?vue&type=style&index=0&id=676e7204&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676e7204"]])

export default __exports__